import { type Column, type ColumnElementType } from '../../types';

type ExistenceCheck = (column: Omit<Column, 'id'>) => boolean;

export const columnElementsExistenceCheckMap: Record<
  ColumnElementType,
  ExistenceCheck
> = {
  title: ({ title }) => !!title,
  button: ({ buttonText }) => !!buttonText,
  picture: ({ picture }) => !!picture?.url,
  price: ({ price: { customPrice, pricingModel } }) =>
    pricingModel !== 'custom' || !!customPrice,
  features: ({ features }) => !!features.length
};
